module.exports = __webpack_public_path__ + "static/Lizard_Man-f4900e868da92e6ffbdd35b36e5aa2c3.jpg";